import { useState } from "react";
import PermissionCheck from "~Common/PermissionCheck";
import { PermissionNames, PermissionOperations } from "~enums/permissions";

type Props = {
  defaultValue: boolean;
  onSave: (value: boolean) => void;
  isAddDisabled?: boolean;
  disabled: boolean;
};

const CheckBoxEditableColumn = ({ defaultValue, onSave, isAddDisabled, disabled }: Props) => {
  const [value, setValue] = useState(defaultValue);

  const handleSave = (value: boolean) => {
    setValue(value);
    onSave(value);
  };

  if (disabled || (isAddDisabled && !value)) {
    return <i style={{ cursor: "not-allowed" }} className={value ? "far fa-check-square" : "far fa-square"} />;
  }

  return (
    <PermissionCheck
      permissionKeys={[PermissionNames.ROLES]}
      permissionOptions={value ? [PermissionOperations.CREATE] : [PermissionOperations.DELETE]}
      componentToRender={<i style={{ cursor: "not-allowed" }} className={value ? "far fa-check-square" : "far fa-square"} />}
    >
      <i
        onClick={() => {
          handleSave(!value);
        }}
        style={{ cursor: "pointer" }}
        className={value ? "far fa-check-square" : "far fa-square"}
      />
    </PermissionCheck>
  );
};

export default CheckBoxEditableColumn;
